import { useField } from "@frontend/hooks/form";
import type { ValueFieldOf } from "@frontend/lib/form";

import type { AddressTextField } from "../types";

export type UseAddressText = {
  value: string;
  setValue: (value: string) => void;
  error: string | null;
};

/**
 * The value read as a string and written as one. A form storing `null` for an
 * empty address line takes `""` just as well, and its own payload assembler is
 * what turns it back into `null`.
 */
export function useAddressText(field: AddressTextField): UseAddressText {
  const { value, setValue, error } = useField(
    field as ValueFieldOf<string | null | undefined>,
  );

  return { value: value ?? "", setValue, error };
}
